<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      no-body
      class="text-center mt-2"
      header="Cikk szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <!-- <b-row class="container mt-2">
        <b-col md="2">
          <div class="form-group">
            <label for="beszerdatum">Beszerzés dátuma</label>
            <b-form-input
              size="sm"
              type="date"
              v-model="list.beszerdatum"
              class="form-control"
              id="beszerdatum"
            />
          </div>
        </b-col>
        <b-col md="2">
          <div class="form-group">
            <label for="garancia">Garancia</label>
            <b-form-input
              size="sm"
              type="text"
              v-model="list.garancia"
              class="form-control"
              id="garancia"
            />
          </div>
        </b-col>
        <b-col md="2">
          <div class="form-group">
            <label for="mennyiseg">Mennyiség</label>
            <b-form-input
              size="sm"
              type="text"
              v-model="list.mennyiseg"
              class="form-control"
              id="mennyiseg"
            />
          </div>
        </b-col>
      </b-row> -->

      <b-card-body class="text-left">
        <div class="col-sm">
          <div class="row-fluid">

            <!-- // FORM -->
            <form v-on:submit.prevent="addElement">
            <!-- <b-form @submit="addElement"> -->

              <!-- <b-form-group label="Megnevezés" label-for="nev" label-cols-sm="3" label-align-sm="left">
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.nev"
                  class="form-control" id="nev"
                ></b-form-input>
              </b-form-group> -->

              <b-form-group label="Megnevezés" label-for="nev" label-cols-sm="3" label-align-sm="left">
                <vue-typeahead-bootstrap
                  class="text-left"
                  ref="megnevezes_typeahead"
                  :maxMatches="100"
                  :minMatchingChars="0"
                  size="sm"
                  v-model="query"
                  :data="cikkekList"
                  :serializer="item => `${item.nev}`"
                  @hit="cikkSelect = $event"
                  @keyup="fillData"
                  placeholder="terméknév"
                  :disabledValues="(cikkSelect ? [cikkSelect.nev] : [])"
                  />
              </b-form-group>

              <b-form-group  label="Gyártó" label-for="gyartok" label-cols-sm="3" label-align-sm="left">
                <b-form-select v-model="gyartokSelect" :options="gyartokList" size="sm" id="gyartok" required></b-form-select>
              </b-form-group>

              <b-form-group  label="Cikkcsoport" label-for="cikkcsoport" label-cols-sm="3" label-align-sm="left">
                <b-form-select v-model="cikkcsoportSelect" :options="cikkcsoportList" size="sm" id="cikkcsoport"  required></b-form-select>
              </b-form-group>

              <b-form-group  label="Vonalkód" label-for="vonalkod" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.vonalkod" class="form-control" id="vonalkod"></b-form-input>
              </b-form-group>

              <b-form-group  label="Cikkszám" label-for="cikkszam" label-cols-sm="3" label-align-sm="left">
                <b-form-input @keydown.enter="a" size="sm" type="text" v-model="list.cikkszam" class="form-control" id="cikkszam"></b-form-input>
              </b-form-group>

              <b-form-group  label="Mennyiségi egység" label-for="mennyisegiegyseg" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.mennyisegiegyseg" class="form-control" id="mennyisegiegyseg" required></b-form-input>
              </b-form-group>

              <b-form-group  label="Nettó beszerzési ár" label-for="nettobeszar" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="number" step="0.01" v-model="list.nettobeszar" class="form-control" id="nettobeszar"  required></b-form-input>
              </b-form-group>

              <b-form-group  label="Bruttó fogyasztási ár" label-for="bruttofogyar" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="number" v-model="list.bruttofogyar" class="form-control" id="bruttofogyar"  required></b-form-input>
              </b-form-group>

              <b-form-group v-if="!bevmode" label="Készleten" label-for="Készleten" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="number" v-model="list.mennyiseg" class="form-control" id="mennyiseg"></b-form-input>
              </b-form-group>

              <b-form-group  label="Gyáriszámsos termék" label-for="cikkszam" label-cols-sm="3" label-align-sm="left">
                <b-form-checkbox
                  id="gyariszamos"
                  v-model="list.gyariszamos"
                  name="gyariszamos"
                  value="1"
                  unchecked-value="0"
                >
                  Minden termékhez külön gyáriszám tartozik
                </b-form-checkbox>
              </b-form-group>

              <b-form-group label="Bevmód" label-for="Bevmód" label-cols-sm="3" label-align-sm="left" hidden >
                <b-form-input size="sm" type="number" v-model="bevmode" class="form-control" id="bevmode"></b-form-input>
              </b-form-group>

              <!-- // SAVE -->
              <b-button variant="primary" type="submit">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés</b-button>

              <!-- // CANCEL   @click="$router.push({name: 'Cikkek'})"-->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="selfClose"
                ><b-icon-arrow-left></b-icon-arrow-left>
                Mégsem</b-button
              >
            </form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  props: [
    'bevmode',
    'itemId',
    'newProduct'
  ],
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      cikkekList: [],
      cikkSelect: [],
      gyartokList: [],
      gyartokSelect: [],
      cikkcsoportList: [],
      cikkcsoportSelect: {},
      list: {},
      query: ''
    }
  },

  methods: {
    // bevmode === 1 Create
    // bevmode === 2 Edit
    selfClose () {
      if (this.bevmode === 1 || this.bevmode === 2) {
        console.log('SDD')
        this.$bvModal.hide('modal-xl')
        this.$bvModal.hide('edit-product')
        // this.$emit('close-product')
      } else {
        router.push({name: 'Cikkek'})
      }
    },
    typeaheadHit () {
      console.log('HIHIHHHHIH')
      this.list.nev = this.$refs.megnevezes_typeahead.inputValue
    },
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.list.id
        payload.nev = this.query
        payload.mennyisegiegyseg = this.list.mennyisegiegyseg
        payload.gyartoid = this.gyartokSelect.id
        payload.csikcsoportid = this.cikkcsoportSelect.id
        payload.vonalkod = this.list.vonalkod
        payload.cikkszam = this.list.cikkszam
        payload.nettobeszar = this.list.nettobeszar
        payload.bruttofogyar = this.list.bruttofogyar
        payload.mennyiseg = this.list.mennyiseg
        payload.gyariszamos = this.list.gyariszamos
        payload.hidden = 1
        payload.bevmode = this.bevmode
        payload.itemId = this.itemId
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post(process.env.ROOT_API + '/cikkek/save', { payload })
          .then(res => {
            let myNewProduct = res.data.newProduct
            console.log('this.list')
            this.list = {}
            console.log(this.list)
            if (res.data.bevmode === 1) {
              console.log('bevmode === 1')
              this.$emit('update-number', myNewProduct)
            } else
            if (res.data.bevmode === 2) {
              console.log('bevmode === 2')
              this.$emit('edit-product', myNewProduct)
            } else {
              router.push({ name: 'Cikkek' })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    loadList () {
      let id = this.$route.params.id
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (this.$route.params.id) {
          payload.id = id
        } else if (this.itemId !== 0) {
          payload.id = this.itemId
        }
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post(process.env.ROOT_API + '/cikkek/edit', { payload })
          .then(res => {
            this.list = res.data
            this.query = res.data.nev
            this.gyartokSelect = res.data.gyartoModel
            this.cikkcsoportSelect = res.data.csikkCsoportModel
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    fillData: function () {
      this.list.nev = this.query
      // this.list.mennyisegiegyseg = 'this.cikkSelect.mennyisegiegyseg'
      // this.gyartokSelect = this.gyartokList.find(el => this.cikkSelect.gyartoid).value
      // this.cikkcsoportSelect = this.cikkcsoportList.find(el => this.cikkSelect.csikcsoportid).value
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      if ((this.$route.params.id || this.itemId !== 0) && this.bevmode !== 1) {
        this.loadList()
      }
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      axios
        .post(process.env.ROOT_API + '/gyartok/getlist', { payload })
        .then(res => {
          for (var el in res.data) {
            this.gyartokList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes,
                id: res.data[el].id
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
      axios
        .post(process.env.ROOT_API + '/cikkcsoport/getlist', { payload })
        .then(res => {
          for (var el in res.data) {
            this.cikkcsoportList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes,
                id: res.data[el].id
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
        // Cikkek
      axios.post(process.env.ROOT_API + '/cikkek/getquicksearchlist', {payload})
        .then((res) => {
          this.cikkekList = res.data
        // for (var el in res.data) {
        //   this.cikkekList.push(
        //     {
        //       value: res.data[el],
        //       text: res.data[el].nev
        //     }
        //   )
        // }
        }).catch((err) => {
          console.log(err)
        })
    }
  },
  watch: {
    cikkSelect: function () {
      this.fillData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CikkekNew.vue